<template>
  <div class="balloon balloon-buttons" @click.shift.left.exact="bubbleShift">
    <div class="buttons-template-title">
      {{ message.payload.message }}
    </div>
    <div class="buttons-template-content">
      <div v-for="(button, j) in message.payload.buttons" :key="j">
        {{ button.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayloadButton',
  props: {
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
